<template>
  <div v-bind:data-version="store.version">
    <header ref="TempBoard1" class="globalHeader" v-if="this.store.modeStorytelling != 'story'">
      <h2>Der Weg zum Klimaziel 2030</h2>
      <p>{{ store.dataTimestamp }}</p>
    </header>
    <div class="globalBoard">
      <TempBoard ref="TempBoard" v-on:child-event="toggleBoardTemp" data-state="open"></TempBoard>
      <EmissBoard
        ref="EmissBoard"
        v-on:child-event="toggleBoardEmiss"
        data-state="closed"
        class="emiss closed"
      ></EmissBoard>
      <ElecBoard ref="ElecBoard" v-on:child-event="toggleBoardElec" data-state="closed" class="elec closed"></ElecBoard>
    </div>
    <footer>
      <div>
        <span v-if="this.store.modeStorytelling == 'story'" class="storyTimestamp">{{ store.dataTimestamp }}</span>
      </div>
      <button v-if="this.store.linkStorytelling != ''" type="button" class="globalLink" v-on:click="lnkMore">
        Mehr Klimafakten
      </button>
    </footer>
  </div>
</template>

<script>
import { store } from "../store";

import EmissBoard from "./emissBoard.vue";
import TempBoard from "./tempBoard.vue";
import ElecBoard from "./elecBoard.vue";

export default {
  components: {
    TempBoard,
    EmissBoard,
    ElecBoard,
  },
  data() {
    return {
      store,
    };
  },
  methods: {
    lnkMore() {
      window.location.href = this.store.linkStorytelling;
    },
    toggleBoardTemp() {
      const childTemp = this.$refs.TempBoard;
      const childEmiss = this.$refs.EmissBoard;
      const childElec = this.$refs.ElecBoard;
      // Get a reference to the child component element
      const childElementTemp = childTemp.$el;
      const childElementEmis = childEmiss.$el;
      const childElementElec = childElec.$el;
      // Toggle the "my-class" class on the child component element

      if (childElementTemp.getAttribute("data-state") === "open") {
        childElementTemp.classList.add("closed");
        childElementTemp.setAttribute("data-state", "closed");
      } else {
        childElementTemp.classList.remove("closed");
        childElementEmis.classList.add("closed");
        childElementElec.classList.add("closed");

        childElementTemp.setAttribute("data-state", "open");
        childElementEmis.setAttribute("data-state", "closed");
        childElementElec.setAttribute("data-state", "closed");
      }
    },
    toggleBoardEmiss() {
      const childTemp = this.$refs.TempBoard;
      const childEmiss = this.$refs.EmissBoard;
      const childElec = this.$refs.ElecBoard;
      // Get a reference to the child component element
      const childElementTemp = childTemp.$el;
      const childElementEmis = childEmiss.$el;
      const childElementElec = childElec.$el;
      // Toggle the "my-class" class on the child component element

      if (childElementEmis.getAttribute("data-state") === "open") {
        childElementEmis.classList.add("closed");
        childElementEmis.setAttribute("data-state", "closed");
      } else {
        childElementEmis.classList.remove("closed");
        childElementTemp.classList.add("closed");
        childElementElec.classList.add("closed");

        childElementEmis.setAttribute("data-state", "open");
        childElementTemp.setAttribute("data-state", "closed");
        childElementElec.setAttribute("data-state", "closed");
      }
    },
    toggleBoardElec() {
      const childTemp = this.$refs.TempBoard;
      const childEmiss = this.$refs.EmissBoard;
      const childElec = this.$refs.ElecBoard;
      // Get a reference to the child component element
      const childElementTemp = childTemp.$el;
      const childElementEmis = childEmiss.$el;
      const childElementElec = childElec.$el;
      // Toggle the "my-class" class on the child component element

      if (childElementElec.getAttribute("data-state") === "open") {
        childElementElec.classList.add("closed");
        childElementElec.setAttribute("data-state", "closed");
      } else {
        childElementElec.classList.remove("closed");
        childElementTemp.classList.add("closed");
        childElementEmis.classList.add("closed");

        childElementElec.setAttribute("data-state", "open");
        childElementTemp.setAttribute("data-state", "closed");
        childElementEmis.setAttribute("data-state", "closed");
      }
    },
  },
  mounted() {
    fetch(store.urlTimeStamp)
      .then((response) => response.json())
      .then((data) => {
        //this.posts = data
        store.dataTimestamp = data.annotate.notes;
      });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
:root {
  --popper-theme-background-color: #333333;
  --popper-theme-background-color-hover: #333333;
  --popper-theme-text-color: #ffffff;
  --popper-theme-border-width: 0px;
  --popper-theme-border-style: solid;
  --popper-theme-border-radius: 2px;
  --popper-theme-padding: 5px;
  --popper-theme-box-shadow: 0 4px 50px 0px rgba(0, 0, 0, 0.25);
}
</style>
